.geofenceMap {
	width: 100%;
	height: 400px;
	position: relative;
	outline-style: none;

	:global(.leaflet-control-zoom),
	:global(.leaflet-control-locate) {
		border-radius: 5px;
		border-width: 0;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
		overflow: hidden;
		box-sizing: border-box !important;
	}

	:global(.leaflet-bar a:hover) {
		background-color: #42296e;
		color: #fff;
	}

	:global(.location-me-active) {
		padding: 0 !important;
	}

	:global(.leaflet-control-locate-location-arrow) {
		/* Convert default background img to purple color */
		filter: invert(21%) sepia(51%) saturate(1234%) hue-rotate(228deg) brightness(91%) contrast(94%) !important;
	}

	/* Make arrow on white*/
	:global(.leaflet-bar a:hover .leaflet-control-locate-location-arrow) {
		filter: brightness(0) invert(1) !important;
	}

	:global(.leaflet-marker-icon:focus-visible) {
		outline: 2px solid var(--focus-outline-color-dark);
	}
}

.geofenceContainer {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
}

.geofenceRow {
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 0.5rem;
	align-items: flex-start;
	justify-content: flex-start;
}

.radiusContainer {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: 0.625rem 0.9375rem;
	border: 1px solid #e5e7eb99;
	background: linear-gradient(135deg, #f9fafb 0%, rgba(250, 245, 255, 0.3) 100%);
	border-radius: 14px;
}

.radiusRow {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;

	& .description {
		color: #6b6b6b;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
	}

	& .title {
		color: #565759;
		font-weight: 600;
		font-size: 0.875rem;
		line-height: 1.6;
	}

	& .radiusLabel {
		color: #6a7282;
		font-size: 0.875rem;
		font-weight: 600;
		line-height: 1.6;
	}
}

.toolbarFormControl:global(.MuiFormControlLabel-root) {
	align-items: flex-start;
	margin: 0;

	&:has(.geofenceLocationTextfield) {
		flex: 1;
	}

	& .geofenceLocationTextfield {
		width: 100%;
		align-items: flex-start;

		& :global(.MuiOutlinedInput-root) {
			width: 100%;
		}
	}

	& .radiusTextField {
		align-items: flex-start;
	}

	& :global(.MuiFormControlLabel-label) {
		color: #000000;
		font-size: 0.9375rem;
		font-weight: 600;
		line-height: 1.5;
		padding-left: 0.25rem;
	}

	& .unitDropdown {
		width: 75px;
	}
}

@media (max-width: 768px) {
	.geofenceRow {
		flex-direction: column;

		.toolbarFormControl {
			width: 100%;
			.radiusTextField {
				width: 100%;

				& :global(.MuiOutlinedInput-root) {
					width: 100%;
				}
			}

			.unitDropdown {
				width: 100%;
			}
		}
	}

	.radiusRow.header {
		flex-direction: column;
		justify-content: center;
		gap: 0.5rem;
	}
}
